import "./RescheduleAppointmentComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import SkeletonCard from "../../../../shared/components/skeleton-card/SkeletonCard";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../../constants";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import {Typography} from "antd";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import ProviderDetailsModalComponent
    from "../../../book-appointment/facility-carousel/provider-details-modal/ProviderDetailsComponent";
import BookAppointmentCalender
    from "../../../../shared/components/book-appoiinterment-calender/BookAppointmentCalender";
import moment from "moment";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import momentTimezone from "moment-timezone";
import DataIconValueComponent from "../../../../shared/components/data-icon-value/DataIconValueComponent";

const {Paragraph} = Typography;

interface RescheduleAppointmentComponentProps {
    appointmentDetails?: any
    setIsCategoryServiceModalOpen?: any
    setIsReschedulingAppointmentModalOpen?: any
    fetchAppointmentDetails?: any
}

const RescheduleAppointmentComponent = (props: RescheduleAppointmentComponentProps) => {
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {
        appointmentDetails,
        setIsCategoryServiceModalOpen,
        setIsReschedulingAppointmentModalOpen,
        fetchAppointmentDetails
    } = props;
    const [selectedScreen, setSelectedScreen] = useState<'facility_selection' | 'provider_selection' | 'date-time-selection'>("facility_selection");
    const [isFacilityWithProvidersDetailsLoading, setIsFacilityWithProvidersDetailsLoading] = React.useState<boolean>(false);
    const [facilityWithProvidersDetails, setFacilityWithProvidersDetails] = React.useState<Array<any>>([]);
    const [selectedFacilityDetails, setSelectedFacilityDetails] = useState<any>(null);
    const [selectedProviderDetails, setSelectedProviderDetails] = useState<any>(null);
    const [selectedDate, setSelectedDate] = useState<any>("");
    const [providerListBasedOnCategoryFacilitySelected, setProviderListBasedOnCategoryFacilitySelected] = useState<any>(null);
    const [isProviderListLoading, setIsProviderListLoading] = React.useState<boolean>(false);
    const [isProviderDetailsModalOpen, setIsProviderDetailsModalOpen] = useState<boolean>(false);
    const [isProviderDetailsLoading, setIsProviderDetailsLoading] = useState<boolean>(false);
    const [providerDetails, setProviderDetails] = useState<any>(undefined);
    const [selectedTime, setSelectedTime] = useState<any>(null);
    const [availableProviderTimings, setAvailableProviderTimings] = useState<any>([]);
    const [isAvailableProviderTimingsLoading, setIsAvailableProviderTimingsLoading] = useState<boolean>(false);
    const [availableProviderDates, setAvailableProviderDates] = useState<any>([]);
    const [isAvailableProviderDatesLoading, setIsAvailableProviderDatesLoading] = useState<boolean>(false);
    const [isReschedulingAppointmentProcessing, setIsReschedulingAppointmentProcessing] = useState<boolean>(false);
    const [isReschedulingAppointmentSuccessModalOpen, setIsReschedulingAppointmentSuccessModalOpen] = useState<boolean>(false);

    const fetchFacilityList = useCallback(() => {
        let initialFacilityWithProvidersDetails: any = [];
        setIsFacilityWithProvidersDetailsLoading(true);
        CommonService._bookAppointment.GetFacilityWithProvidersAPICall()
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialFacilityWithProvidersDetails = response.data;
                }
                setFacilityWithProvidersDetails(initialFacilityWithProvidersDetails);
                setIsFacilityWithProvidersDetailsLoading(false);
            }).catch((error: any) => {
            setFacilityWithProvidersDetails(initialFacilityWithProvidersDetails);
            setIsFacilityWithProvidersDetailsLoading(false);
        })
    }, []);

    const fetchProviderDetails = useCallback((providerId: string) => {
        let initialProviderDetails: any = [];
        setIsProviderDetailsLoading(true);
        CommonService._bookAppointment.GetProviderDetails(providerId)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderDetails = response.data;
                }
                setProviderDetails(initialProviderDetails);
                setIsProviderDetailsLoading(false);
            }).catch((error: any) => {
            setProviderDetails(initialProviderDetails);
            setIsProviderDetailsLoading(false);
        })
    }, [])

    const fetchLinkedProviderList = useCallback(() => {
        let initialProviderList: any = [];
        setIsProviderListLoading(true)
        CommonService._bookAppointment.GetProvidersListBasedOnSelectedFacilityAndCategory(selectedFacilityDetails?._id, appointmentDetails?.service_details?._id, {})
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderList = response.data;
                }
                setProviderListBasedOnCategoryFacilitySelected(initialProviderList);
                setIsProviderListLoading(false)
            }).catch((error: any) => {
            setProviderListBasedOnCategoryFacilitySelected(initialProviderList);
            setIsProviderListLoading(false)
        })
    }, [selectedFacilityDetails, appointmentDetails?.service_details?._id]);

    useEffect(() => {
        fetchFacilityList();
    }, [fetchFacilityList]);

    useEffect(() => {
        fetchLinkedProviderList()
    }, [fetchLinkedProviderList]);

    const handleProviderDetailsModalClose = useCallback(() => {
        setIsProviderDetailsModalOpen(false);
        setSelectedScreen("provider_selection")
    }, []);

    const fetchProviderAvailableTimings = useCallback((availableDate: any) => {
        setIsAvailableProviderTimingsLoading(true);
        let initialProviderAvailableTimings: any = [];
        let payload: any = {}
        payload.service_id = appointmentDetails?.service_details?._id
        payload.duration = appointmentDetails?.duration;
        payload.facility_id = selectedFacilityDetails?._id;
        payload.available_on = availableDate;

        CommonService._bookAppointment.GetProviderAvailableTimings(selectedProviderDetails?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderAvailableTimings = response.data;
                }
                setAvailableProviderTimings(initialProviderAvailableTimings);
                setIsAvailableProviderTimingsLoading(false);
            }).catch((error: any) => {
            setAvailableProviderTimings(initialProviderAvailableTimings);
            setIsAvailableProviderTimingsLoading(false);
        })
    }, [selectedProviderDetails, appointmentDetails, selectedFacilityDetails]);

    const fetchProviderAvailableDates = useCallback((providerId: any) => {
        setIsAvailableProviderDatesLoading(true);
        let initialProviderAvailableDates: any = [];
        let payload: any = {}
        payload.service_id = appointmentDetails?.service_details?._id
        payload.duration = appointmentDetails?.duration;
        payload.facility_id = selectedFacilityDetails?._id;
        CommonService._bookAppointment.GetProviderAvailableDates(providerId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderAvailableDates = response.data;
                }
                setAvailableProviderDates(initialProviderAvailableDates);
                setIsAvailableProviderDatesLoading(false);
            }).catch((error: any) => {
            setAvailableProviderDates(initialProviderAvailableDates);
            setIsAvailableProviderDatesLoading(false);
        })
    }, [appointmentDetails, selectedFacilityDetails]);


    const rescheduleAppointmentApiCall = useCallback(() => {
        setIsReschedulingAppointmentProcessing(true);
        const payload = {
            start_time: selectedTime?.timeFrame?.start_time,
            end_time: selectedTime?.timeFrame?.end_time,
            provider_id: selectedProviderDetails?._id,
            appointment_date: selectedDate,
            facility_id: selectedFacilityDetails?._id,
            appointment_dateTime_utc: CommonService.convertDateToLocalTimeZone(
                selectedDate,
                selectedTime?.timeFrame?.start_time,
                momentTimezone.tz.guess(),
            )
        }
        CommonService._appointment.rescheduleAppointment(appointmentDetails._id, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setIsReschedulingAppointmentProcessing(false);
                setIsReschedulingAppointmentSuccessModalOpen(true);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
                setIsReschedulingAppointmentProcessing(false);
            });
    }, [appointmentDetails, selectedProviderDetails, selectedTime, selectedFacilityDetails, selectedDate, setIsReschedulingAppointmentProcessing]);

    return (
        <div className={'d-flex'} style={{width: '100%'}}>
            <ModalComponent
                isOpen={isProviderDetailsModalOpen}
                onClose={handleProviderDetailsModalClose}
            >
                <div
                    className="book-appointment-modal-container d-flex justify-content-center align-items-center">
                    <ProviderDetailsModalComponent
                        setIsProviderDetailsModalOpen={setIsProviderDetailsModalOpen}
                        providerDetails={providerDetails}
                        isProviderDetailsLoading={isProviderDetailsLoading}
                        setSelectedScreen={setSelectedScreen}
                    />
                </div>
            </ModalComponent>
            <ModalComponent isOpen={isReschedulingAppointmentSuccessModalOpen}
                            size={'xs'}
                            className=""
                            onClose={() => setIsReschedulingAppointmentSuccessModalOpen(true)}>

                <div className={'success-popup-component'}>
                    <div className={'success-popup-image'}>
                        <img src={ImageConfig.Tick} alt={'success-popup-tick'}/>
                    </div>
                    <div className="success-popup-meta">
                        <div className={'success-popup-title'}>
                            Appointment Rescheduled!
                        </div>
                        <div className={'success-popup-sub-title'}>
                            Thank you for booking with us!
                        </div>
                        <div className={'success-popup-description reschedule-appointment-success-popup-des mrg-bottom-25'}>
                            Your appointment at <span
                            className={'facility-name-text-reschedule'}>{selectedFacilityDetails?.name} </span>
                            has been
                            rescheduled:
                        </div>
                        <div className="slot-details">
                            <div className={'d-flex'}>
                                <div className={'flex-1 d-flex justify-content-end align-items-center'}>
                                    <DataIconValueComponent>
                                        From:
                                    </DataIconValueComponent>

                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.UserIcon/>}>
                                        {appointmentDetails?.provider_details?.first_name} {appointmentDetails?.provider_details?.last_name}
                                    </DataIconValueComponent>
                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.CalendarIcon/>}>
                                        {moment(appointmentDetails?.appointment_date).format('yyyy-MM-DD')}
                                    </DataIconValueComponent>
                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.TimeIcon/>}>
                                        {CommonService.getHoursAndMinutesFromMinutes(appointmentDetails?.start_time)}
                                    </DataIconValueComponent>
                                </div>
                            </div>
                            <div className={'d-flex'}>
                                <div className={'flex-1 d-flex justify-content-end align-items-center'}>
                                    <DataIconValueComponent>
                                        To:
                                    </DataIconValueComponent>
                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.UserIcon/>}>
                                        {selectedProviderDetails?.first_name} {selectedProviderDetails?.last_name}
                                    </DataIconValueComponent>
                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.CalendarIcon/>}>
                                        {selectedDate}
                                    </DataIconValueComponent>
                                </div>
                                <div className={'flex-2 d-flex  align-items-center'}>
                                    <DataIconValueComponent icon={<ImageConfig.TimeIcon/>}>
                                        {CommonService.getHoursAndMinutesFromMinutes(selectedTime?.timeFrame?.start_time)}
                                    </DataIconValueComponent>
                                </div>
                            </div>
                        </div>
                        <div className={'success-popup-cta'}>
                            <ButtonComponent
                                className={'width-80 mrg-bottom-20'}
                                onClick={() => {
                                    setIsReschedulingAppointmentModalOpen(false);
                                    fetchAppointmentDetails();
                                    setIsReschedulingAppointmentSuccessModalOpen(false)

                                }}>
                                Close
                            </ButtonComponent>
                        </div>
                    </div>
                </div>
            </ModalComponent>

            <div className="appointment-details_modal__left-container">
                <div className="appointment-details_modal__left-container-header__wrapper">
                    <div className="appointment-details_modal__left-container__title">Appointment Details</div>
                    <div className="appointment-details_modal__left-container__button_section">
                        <div className="appointment-details_modal__left-container__button">
                            {appointmentDetails?.appointment_type === 'followup_consultation' ? 'Followup Consultant' : 'Int Consult'}
                        </div>
                        &nbsp;&nbsp;
                        <div className="appointment-details_modal__left-container__button">
                            <span><ImageConfig.TimerIcon/></span>
                            {appointmentDetails?.duration} min
                        </div>
                    </div>
                </div>
                <div className={'selected-client-details mrg-bottom-10 mrg-top-10'}>
                    Client: {currentUser?.profile_viewing_as?.first_name ? currentUser?.profile_viewing_as?.first_name : currentUser?.first_name}&nbsp;{currentUser?.profile_viewing_as?.last_name ? currentUser?.profile_viewing_as?.last_name : currentUser?.last_name} | {CommonService.formatPhoneNumber(currentUser?.profile_viewing_as?.primary_contact_info?.phone ? currentUser?.profile_viewing_as?.primary_contact_info?.phone : currentUser?.primary_contact_info?.phone)}
                </div>

                <div className={'category-details-holder_book_appointment_flow d-flex'}>
                    <div className={'active-status-show-on-card'}></div>
                    <div className={'pdd-20'}>
                        <div className={'d-flex'}>
                            <div className={'d-flex ts-justify-content-center align-items-center'}>
                                <img className={'details-image'}
                                     src={appointmentDetails?.category_details?.image?.url}
                                     width={60} height={40}
                                     alt={appointmentDetails?.category_details?.name}/>
                            </div>
                            <div className={'category-details-text-wrapper mrg-left-20'}>
                                <div
                                    className={'category-name-text-in-details mrg-bottom-5'}>{appointmentDetails?.category_details?.name}</div>
                                <div>
                                    <Paragraph className={'category-description-wrapper'}
                                               ellipsis={{rows: 2, expandable: false}}>
                                        <div
                                            dangerouslySetInnerHTML={{__html: appointmentDetails?.category_details?.description}}/>
                                    </Paragraph>
                                    <div className={"appointment-blue-text"} onClick={() => {
                                        setIsCategoryServiceModalOpen(true)
                                    }}>
                                        Read more
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {selectedFacilityDetails &&
                    <div className={'facility-details-holder flex-1 mrg-top-25'}>
                        <div className={'mrg-bottom-10 facility-details-header-text'}>Facility Details</div>
                        <div className={'d-flex  align-items-center'}>
                            <div><ImageConfig.FacilityIcon/></div>
                            <div className={'mrg-left-15'}>
                                <div className={'facility-name-text'}>{selectedFacilityDetails?.name}</div>
                                <div
                                    className={'facility-address-text mrg-top-5'}>{CommonService?.formatAddressBillAppointment(selectedFacilityDetails?.address)}</div>
                            </div>
                        </div>
                    </div>}
                {selectedProviderDetails &&
                    <div className={'date-time-details-holder'}>
                        <div className={'mrg-bottom-10 facility-details-header-text'}>Provider Details</div>
                        <div className={'d-flex  align-items-center'}>
                            <div className="date-logo-avatar"><ImageConfig.ProfileIconName color={"#B7E3FF"}/></div>
                            <div className={'mrg-left-15'}>
                                <div
                                    className={'facility-name-text'}>{selectedProviderDetails?.first_name}&nbsp;{selectedProviderDetails?.last_name}</div>
                                <div className={'provider-professional-text mrg-top-5'}>
                                    {selectedProviderDetails?.professional_designation}
                                </div>
                                {/*<div*/}
                                {/*    className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>*/}
                            </div>
                        </div>
                    </div>}
            </div>


            <div className="appointment-details_modal__right-container">
                <div
                    className={`reschedule-appointment-component ${isFacilityWithProvidersDetailsLoading ? "pdd-bottom-20" : ""}`}>
                    {isFacilityWithProvidersDetailsLoading &&
                        <SkeletonCard/>
                    }
                    {!isFacilityWithProvidersDetailsLoading &&
                        <div className={'reschedule-right__flow_content'}>
                            <div className={'previous-button d-flex justify-content-space-between'}>
                                <div>
                                    {selectedScreen !== "facility_selection" &&
                                        <div className={'d-flex'}>
                                            <div
                                                className={'back-arrow-holder d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                                                onClick={() => {
                                                    if (selectedScreen === "provider_selection") {
                                                        setSelectedScreen("facility_selection")
                                                    } else if (selectedScreen === "date-time-selection") {
                                                        setSelectedScreen("provider_selection")
                                                        setSelectedTime(null)
                                                        setSelectedDate("")
                                                    }
                                                    //    dispatch(setBookingAppointmentFlowNavigation("client_type_selection"));
                                                }}>
                                                <ImageConfig.LeftArrow color={"#07213C"}/>
                                            </div>
                                            <div
                                                className={'previous-text d-flex ts-justify-content-center align-items-center mrg-left-10'}>
                                                Previous
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className={'cursor-pointer'}
                                     onClick={() => {
                                         setIsReschedulingAppointmentModalOpen(false)
                                     }}>
                                    <ImageConfig.CloseIcon color={"#1479FF"}/>
                                </div>
                            </div>
                            <div
                                className={'d-flex  align-items-center justify-content-center mrg-top-30 mrg-bottom-30'}>
                                <div
                                    className={'common-header-for-book-appointment'}>Select {selectedScreen === "facility_selection" ? "Facility" : selectedScreen === "date-time-selection" ? `${availableProviderTimings?.length > 0 ? "Date and Time" : "Date"}` : selectedScreen === "provider_selection" ? "Provider" : ""}
                                </div>
                            </div>
                            <div
                                className={`flex-1 booking-content-wrapper ${!isProviderListLoading && selectedScreen === "provider_selection" && providerListBasedOnCategoryFacilitySelected?.length === 0 && "d-flex ts-justify-content-center align-items-center"}`}>
                                {selectedScreen === "facility_selection" &&
                                    <div className={'facility-wrapper'}>
                                        {facilityWithProvidersDetails && facilityWithProvidersDetails.length > 0 && facilityWithProvidersDetails?.map((facility: any) => {
                                            return (
                                                <div className={'facility-card'}>
                                                    <div
                                                        className={`fancy-card-container ${selectedFacilityDetails?._id === facility?._id ? "facility-active" : "facility-not-active"}`}
                                                        onClick={() => {
                                                            setSelectedFacilityDetails(facility)
                                                            setSelectedScreen("provider_selection")
                                                        }}>
                                                        {/*<div className="fancy-icon-circle">*/}
                                                        {/*    {!facility?.image?.url && <div>*/}
                                                        {/*        {CommonService.FirstLetterCapitalizeWord(facility?.name)}*/}
                                                        {/*    </div>}*/}
                                                        {/*    {facility?.image?.url &&*/}
                                                        {/*        <img src={facility?.image.url} alt=""/>}*/}
                                                        {/*</div>*/}
                                                        <div className="fancy-icon-circle">
                                                            {CommonService.getFirstLetterCapitalized(facility?.name)}
                                                        </div>
                                                        <div className="fancy-card-content">
                                                            <div className="fancy-title">
                                                                {facility?.name}
                                                            </div>
                                                            <div
                                                                className="fancy-address">{CommonService.formatAddressBillAppointment(facility?.address)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                }

                                {
                                selectedScreen === "provider_selection" &&
                                    <div className={'facility-wrapper'}>
                                        {isProviderListLoading && <SkeletonCard/>}
                                        {!isProviderListLoading && providerListBasedOnCategoryFacilitySelected?.length === 0 &&
                                            <div className={'empty-message-text'}>
                                                Oops! It looks like there are no active<br/> providers currently
                                                offering the
                                                selected<br/> service.
                                            </div>}
                                        {!isProviderListLoading && providerListBasedOnCategoryFacilitySelected && providerListBasedOnCategoryFacilitySelected.length > 0 && providerListBasedOnCategoryFacilitySelected?.map((provider: any) => {
                                            return (
                                                <div className={'facility-card'}>
                                                    <div
                                                        className={`fancy-card-container ${selectedProviderDetails?._id === provider?._id ? "facility-active" : "facility-not-active"}`}
                                                        onClick={() => {
                                                            setSelectedProviderDetails(provider)
                                                            setSelectedScreen("date-time-selection")
                                                            fetchProviderAvailableDates(provider?._id)
                                                        }}>
                                                        <div className="fancy-icon-circle">
                                                            {CommonService.getFirstLetterCapitalized(provider?.first_name)}{CommonService.getFirstLetterCapitalized(provider?.last_name)}
                                                        </div>

                                                        <div className="fancy-card-content">
                                                            <div className="fancy-title">
                                                                {provider?.first_name} {provider?.last_name}
                                                            </div>
                                                            <div className={'fancy-designation mrg-top-5'}>
                                                                {provider?.professional_designation}
                                                            </div>
                                                            <div
                                                                className="text-fourteen-font  mrg-top-15 cursor-pointer"
                                                                style={{zIndex: 9999}}
                                                                onClick={() => {
                                                                    setIsProviderDetailsModalOpen(true);
                                                                    fetchProviderDetails(provider?._id);
                                                                }}>
                                                                View Profile
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                                {
                                    selectedScreen === "date-time-selection" &&
                                    <div className={'date-time-wrapper'}>
                                        <div className={'date-time-selection-component'}>
                                            <div className={'d-flex  align-items-center justify-content-center'}>
                                                <div className={'mrg-bottom-20'}>
                                                    <div className={'welcome-back-text'}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className={'pdd-left-40 d-flex ts-justify-content-center align-items-center'}>
                                                {/*<CustomCalendar onDateSelect={(e) => {*/}
                                                {/*    console.log(e)*/}
                                                {/*}}/>*/}
                                                {isAvailableProviderDatesLoading &&
                                                    <div className={'mrg-top-40'}>
                                                        <LoaderComponent type={"spinner"} color={'primary'}/>
                                                    </div>
                                                }
                                                {!isAvailableProviderDatesLoading && !selectedDate &&
                                                    <BookAppointmentCalender calenderSize={"xl"}

                                                                             onDateSelect={(e: any) => {
                                                                                 setAvailableProviderTimings([])
                                                                                 fetchProviderAvailableTimings(moment(e).format('YYYY-MM-DD'))
                                                                                 setSelectedDate(moment(e).format('YYYY-MM-DD'))
                                                                                 setSelectedTime(null)
                                                                             }}
                                                                             enabledDates={availableProviderDates || []}/>}
                                                {!isAvailableProviderDatesLoading && selectedDate &&
                                                    <div className={'d-flex'}>
                                                        <div style={{
                                                            borderRight: "1px solid #EBEBEB"
                                                        }} className={'pdd-right-20'}>
                                                            <BookAppointmentCalender defaultDate={selectedDate} onDateSelect={(e: any) => {
                                                                setAvailableProviderTimings([])
                                                                fetchProviderAvailableTimings(moment(e).format('YYYY-MM-DD'))
                                                                setSelectedDate(moment(e).format('YYYY-MM-DD'))
                                                                setSelectedTime(null)
                                                            }} enabledDates={availableProviderDates || []}/>
                                                            <div className={'d-flex mrg-top-10'}>
                                                                <div className={'mrg-right-5'}><ImageConfig.PhoneIcon
                                                                    color={"#1479FF"}/></div>
                                                                <div className={'details-contact-text'}>
                                                                    If you're unable to find a suitable date and
                                                                    time<br/> or need
                                                                    assistance with booking your
                                                                    appointment,<br/> please call us at
                                                                    <span
                                                                        className={'bold-phone'}> (000) 000-0000.</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={'pdd-left-20'}>
                                                            <div className={'date-details-header mrg-bottom-20'}>
                                                                {selectedDate ? CommonService.formatDateInDayAlphabet(selectedDate) : "No date Selected"}
                                                            </div>
                                                            <div className={'available-times-holder'}>
                                                                {isAvailableProviderTimingsLoading &&
                                                                    <div className={'mrg-top-40 mrg-left-50'}>
                                                                        <LoaderComponent type={"spinner"}
                                                                                         color={'primary'}/>
                                                                    </div>
                                                                }
                                                                {!isAvailableProviderTimingsLoading &&
                                                                    availableProviderTimings?.map((timings: any, index: any) => {
                                                                        return (
                                                                            <div key={index}
                                                                                 className={`time-wrapper mrg-bottom-10 ${selectedTime?.indexNumber === index ? "time-active" : "time-not-active"}`}
                                                                                 onClick={() => {
                                                                                     setSelectedTime({
                                                                                         timeFrame: timings,
                                                                                         indexNumber: index
                                                                                     })
                                                                                 }}
                                                                            >
                                                                                {CommonService.getHoursAndMinutesFromMinutes(timings?.start_time)} - {CommonService.getHoursAndMinutesFromMinutes(timings?.end_time)}
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {!isAvailableProviderDatesLoading && selectedDate &&
                                                <div
                                                    className="login-form__body__controls__button mrg-left-40 mrg-right-40 mrg-top-10">
                                                    <ButtonComponent
                                                        onClick={() => {
                                                            rescheduleAppointmentApiCall()
                                                        }}
                                                        isLoading={isReschedulingAppointmentProcessing}
                                                        fullWidth={true}
                                                        disabled={!selectedDate || !selectedTime}
                                                        suffixIcon={<ImageConfig.RightArrow/>}
                                                    >
                                                        Submit
                                                    </ButtonComponent>
                                                </div>}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default RescheduleAppointmentComponent;
